var LazyBg = (function(){
	function findLazy(){
		$('[data-lazy-bg]').each(function(){
			if(this.getBoundingClientRect().top < (window.innerHeight + 200)){
				var bg = $(this).data('lazy-bg');

				$(this).css('background-image', 'url('+bg+')');
				$(this).removeAttr('data-lazy-bg')
			}
		});
	}

	$(window).scroll(function (){
		findLazy()
	})

	return findLazy();
})();